import { render, staticRenderFns } from "./areaSent.vue?vue&type=template&id=5f764f4c&scoped=true&"
import script from "./areaSent.vue?vue&type=script&lang=js&"
export * from "./areaSent.vue?vue&type=script&lang=js&"
import style0 from "./areaSent.vue?vue&type=style&index=0&id=5f764f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f764f4c",
  null
  
)

export default component.exports